module.exports = __webpack_public_path__ + "static/media/lock-protection-password-svgrepo-com.d4f51742.svg";